import { render, staticRenderFns } from "./DefaultContent-ProductCard.vue?vue&type=template&id=29a8a055&"
import script from "./DefaultContent-ProductCard.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-ProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports